import { render, staticRenderFns } from "./BidHistoryByParticipants.vue?vue&type=template&id=2471a532"
import script from "./BidHistoryByParticipants.vue?vue&type=script&lang=js"
export * from "./BidHistoryByParticipants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports